import { useEffect, useState } from 'react';
import { readPreference, writePreference } from '../lib/storage';

export function useTheme() {
  const [dark, setDark] = useState(() => readPreference('triage-theme') === 'dark');
  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
    writePreference('triage-theme', dark ? 'dark' : 'light');
    // document/localStorage are browser globals, not reactive dependencies.
  }, [dark]);
  return {dark, toggleTheme: () => setDark(current => !current)};
}